<script lang="ts" setup>
import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '../../../models';
import { computed, PropType } from 'vue';
import { TaskCardItemWrapper } from './';
import { formatDate } from '../services';
import { ClockIcon } from 'tir-style-system/icons/outline';

/**Параметры */
const props = defineProps({
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
});

/**Текст с датой дедлайна */
const deadlineDateText = computed(() => formatDate(props.task.Deadline));
</script>
<template>
  <TaskCardItemWrapper :element="element">
    <div v-if="task.Deadline" class="task-card-deadline">
      {{ deadlineDateText }}
    </div>
  </TaskCardItemWrapper>
</template>
<style lang="scss" scoped>
.task-card-deadline {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--text-primary);
}
</style>
